import { useCreateOne } from "src/system/useCreateOne.ts";
import type {
  B2bGateOrderResource,
  StoreB2bGateSupplierOrderPosition,
} from "@exonn/js-sdk";
import { useQueryClient } from "@tanstack/react-query";
import { ResourceEnum } from "src/constants/constants.ts";
import { createModuleQueries } from "src/framework/createModuleQueries.ts";
import { useErpTranslation } from "src/system/useErpTranslation.ts";
import { FormAction } from "src/components/Form/Form.types.ts";

export const useAddProductToOrder = () => {
  const queryClient = useQueryClient();
  const { t } = useErpTranslation({
    resource: ResourceEnum.B2bGateOrder,
    type: "form",
    formType: FormAction.Edit,
  });

  return useCreateOne<
    StoreB2bGateSupplierOrderPosition,
    {
      data: B2bGateOrderResource;
    }
  >({
    errorNotification: {
      message: t("notification.couldNotUpdatePosition"),
    },
    successNotification: {
      message: t("notification.positionHasBeenUpdated"),
    },

    resource: ResourceEnum.B2bGateSupplierOrderPosition,
    onSettled: (data, error, variables) => {
      const queries = createModuleQueries();
      queryClient.setQueryData(
        queries.detail({
          resource: ResourceEnum.B2bGateOrder,
          id: variables.data.b2b_gate_order_id,
          locale: "de",
        }),
        data,
      );
      queryClient.invalidateQueries({
        queryKey: queries.all({
          resource: ResourceEnum.B2bGateOrder,
        }),
      });
    },
  });
};
